import {TuiLink} from "@taiga-ui/core";
import {TuiItem} from "@taiga-ui/cdk";
import {TuiBreadcrumbs} from "@taiga-ui/kit";
import {Component, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {Breadcrumb, BreadcrumbService} from "./breadcrumb.service";
import {CommonModule} from "@angular/common";
import {Router, RouterModule} from "@angular/router";


@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    imports: [CommonModule, TuiBreadcrumbs, TuiItem, TuiLink, RouterModule]
})
export class BreadcrumbComponent implements OnInit {
  public breadcrumbs$: Observable<Breadcrumb[]> = this.breadcrumbService.breadcrumbs$;

  constructor(private readonly breadcrumbService: BreadcrumbService,
              private router: Router) {
  }

  ngOnInit() {
    //когда app-breadcrumb под *ngIf'ом нет возможности получить event NavigationEnd, этот вариант snapshot'ом ициниализирует breadcrumbs.
    this.breadcrumbService.initBreadCrumb(this.router.routerState.snapshot.root);
  }
}
